<script setup>
definePage({
  meta: {
    layout: 'default',
    action: 'equipment-manage',
    subject: 'Mfk',
  },
})

const page = {
  groupTitle: 'Fasilitas (MFK)',
  icon: 'ri-tools-line',
  color: 'secondary',
  title: 'Kalibrasi Alat Kesehatan',
  description: 'Mencatat tanggal jatuh tempo kalibrasi berikutnya untuk sebuah alat.',
  purpose: 'Panduan mencatat jadwal kalibrasi alat kesehatan supaya pengingatnya aktif otomatis.',
  concept: [
    {
      icon: 'ri-calendar-check-line',
      title: 'Cukup Isi Tanggal Jatuh Tempo Berikutnya',
      text: 'Anda tidak perlu mencatat tanggal kalibrasi terakhir atau menghitung interval sendiri — cukup isi kapan kalibrasi BERIKUTNYA jatuh tempo (sesuai SOP/spesifikasi alat masing-masing).',
    },
  ],
  steps: [
    { title: 'Buka menu Fasilitas → Kalibrasi Alat', detail: 'Cari alat yang ingin diperbarui.' },
    { title: 'Klik ikon edit pada baris alat tersebut', detail: 'Muncul dialog kecil untuk mengisi tanggal.' },
    { title: 'Isi "Tanggal Jatuh Tempo Kalibrasi Berikutnya"', detail: 'Sesuai jadwal kalibrasi resmi alat tersebut.' },
    { title: 'Klik "Simpan"', detail: 'Reminder otomatis aktif menjelang tanggal itu.' },
  ],
  tips: [
    'Perbarui tanggal SEGERA setelah kalibrasi baru selesai dilakukan — jangan menunggu, supaya reminder tidak terus muncul padahal sudah dikerjakan.',
  ],
  faq: [
    { q: 'Kenapa tidak ada kolom "tanggal kalibrasi terakhir"?', a: 'Sengaja tidak disediakan — cukup satu kolom (tanggal jatuh tempo berikutnya) untuk menjaga form tetap sederhana. Kalau butuh riwayat kalibrasi lengkap, catat terpisah di luar sistem untuk sekarang.' },
  ],
  related: [
    { title: 'Reminder & Pengingat', sub: 'Rekap jatuh tempo kalibrasi', icon: 'ri-notification-3-line', color: 'info', to: { name: 'help-kepegawaian-reminder-pengingat' } },
    { title: 'Master Data', sub: 'Data dasar Alat Kesehatan', icon: 'ri-database-2-line', color: 'error', to: { name: 'help-administrasi-master-data' } },
  ],
}
</script>

<template>
  <GuidePageLayout v-bind="page" />
</template>
